import React from 'react';
import Meta from 'shared/meta';

export default function PageGenerator(props) {
  const { templates, slug, meta, ...otherProps } = props;
  const children = templates
    .map(({ acf_fc_layout, ...componentProps }, idx) => {
      try {
        const Component = require(`components/templates-shared/${acf_fc_layout}`)
          .default;
        return (
          <Component
            {...componentProps}
            {...otherProps}
            key={`${acf_fc_layout}-${idx}`}
          />
        );
      } catch (e) {
        return null;
      }
    })
    .filter(component => component);
  return (
    <>
      <Meta {...meta} />
      {children}
    </>
  );
}
